<template>
  <div class="py-4 px-4 ">
    <div class="bg-white py-6 px-8">
      <header class="flex justify-between">
        <h2>Claims Form</h2>
        <div @click="back" class="cursor-pointer">
          <img src="../../../assets/images/ondemand/claim-icon-close.svg" alt="" srcset="">
        </div>
      </header>
      <aside class="mt-4">
        <p>Fill out a claims form</p>
      </aside>
      <form action="" @submit.prevent="" >
        <div class="mt-4">
          <label for="">Sender Address</label>
          <input class="px-3 py-2" type="text" v-model="senderAddress" placeholder="Autoloaded">
        </div>
        <div class="mt-4">
          <label for="">Destination Address</label>
          <input class="px-3 py-2" type="text" v-model="destinationAddress" placeholder="Autoloaded">
        </div>
        <div class="mt-4" v-for="item in transaction.shipping.packagees" :key="item">
          <label for="">Item Description</label>
          <input class="px-3 py-2" type="text" v-model="item.description" placeholder="Autoloaded">
        </div>
        <div class="mt-4">
          <label for="">Date Dispatched</label>
          <input class="px-3 py-2" type="text" v-model="dateDispatched" placeholder="Autoloaded">
        </div>
        <div class="mt-4">
          <label for="">Comments</label>
          <textarea v-model="comments" name="" id="" cols="" rows="5" placeholder="text area"
            class="pl-4 pt-2"></textarea>
        </div>
        <input ref="fileInput" type="file" style="display: none;" accept="image/*" @change="onFileSelected">
        <div class="mt-4">
          <button @click.prevent="selectImage" class="flex px-3 py-2">
            <img src="../../../assets/images/ondemand/upload-icon-claim.svg" alt="" srcset="">
            <p>Click to upload an image <span>(optional)</span> </p>
          </button>
        </div>
        <div class="mt-2" v-if="imageUrl">
          <div id="preview" class="flex">
            <img :src="imageUrl" alt="Selected Image" width="300" />
            <span @click="removeImage" class="delete-icon"><img
                src="../../../assets/images/ondemand/claim-icon-close.svg" alt="" srcset=""></span>
          </div>
        </div>
        <hr>
        <div class="button-cover">
          <button class="py-2" @click="back">Cancel</button>
          <button class=" py-2" type="submit">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

export default {
  data() {
      return {
        imageUrl: null,
        transactionId: this.$route.params.id,
        transaction: {},
        senderAddress: '',
        destinationAddress: '',
        itemDescription: '',
        dateDispatched: '',
      };
    },
    mounted() {
      this.getReciept();
    },
  methods: {   
    back() {
      this.$router.go(-1)
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    
    onFileSelected(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith('image/')) {
        this.imageUrl = URL.createObjectURL(file);
        this.$forceUpdate(); 
      } else {
        alert('Please select a valid image file.');
        this.imageUrl = null;  
      }
    },
    removeImage() {
      this.imageUrl = null;
      this.$refs.fileInput.value = ''; 
      this.$forceUpdate(); 
    },

    async getReciept() {
      try {
        let response = await this.$_getReciept(this.transactionId);
        this.transaction = response.data.data.transaction; 
        this.senderAddress = this.transaction.shipping.shipperlocation.address.name
        this.destinationAddress = this.transaction.shipping.consigneelocation.address.name 
        this.itemDescription = this.transaction.shipping.packagees.description 
        this.dateDispatched =  this.transaction.shipping.trip.pickUpVerifiedAt
      } catch (error) {
        this.handleError(error);
      }
    },
  },
}
</script>

<style scoped>

#preview>:nth-child(1){
  margin-right: 10px;
}

h2{
  font-size: 24px;
  font-weight: 600;
  color: #10233E;
}
aside>p{
  font-size: 15px;
  font-weight: 400;
  color:#10233E;
}
form>div>label{
  font-size: 16px;
  font-weight: 600;
  color:#10233E;
}
form>div>input{
  width: 100%; 
  border-radius: 5px; 
  border: 1px solid #DAE8F6;
  background-color: #FBFCFE;
}
form>div>input::placeholder {
  color: #10233E; 
  font-size: 16px; 
  font-weight: 400; 
}
form>div>textarea{
  width: 100%; 
  border-radius: 5px; 
  border: 1px solid #DAE8F6;
  background-color: #FBFCFE;
}
form>div>textarea::placeholder {
  color: #10233E; 
  font-size: 16px; 
  font-weight: 400; 
}
form>div>button{
  width: 100%; 
  border-radius: 5px; 
  border: 1px solid #DAE8F6;
  background-color: #FBFCFE;
}
form>div>button>img{
  margin-right: 10px;
}
span{
  color: #7A90A7;
}
.delete-icon {
  cursor: pointer; 
}
.button-cover{
    display: flex;
    justify-content: space-between;
  }
  .button-cover :nth-child(1){
    border: 1px solid rgba(69, 90, 100, 0.03);
    background: #FFFFFF;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    color: hsl(223, 18%, 27%);
    width: 180px;
  }
  .button-cover :nth-child(2){
    background: #FCC210;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    color: #383F51;
    width: 180px;
  }
hr{
border: 1px solid #EFEFEF;
margin: 40px auto;
}
</style>